import {Api} from "@/repository/api";

export class SaisieRepository extends Api {
    constructor() {
        super("saisies");
    }
}